import type { SortDirection } from "Infrastructure/Api/Api";

export type AwaitingVerificationParams = {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortDirection?: SortDirection;
  login?: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  companyNumber?: string;
  roleCodes?: Array<string>;
};

// Keep in sync with AwaitingVerificationFilterRequest.AllowedSortColumns on BE.
// Shared by UserVerificationTable and BankVerificationTable — both consume the
// same endpoint and therefore the same sort column set.
export const AWAITING_VERIFICATION_SORT_COLUMN_MAP: Record<string, string> = {
  login: "Login",
  firstName: "Party.FirstName",
  lastName: "Party.LastName",
  companyName: "Party.CompanyName",
  companyNumber: "Party.CompanyNumber",
  dateCreated: "DateCreated",
};
